
import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Loader from "../../Component/Loader/index";
import ProtectedRoute from "./ProtectedRoute";
import Layout from "../Layout/index";

import HR from "./modules/HrRoutes/Hr";
import { TravelRoute } from "./modules/TravelRoute/TravelRoute";
import { TADARoute } from "./modules/TADARoute/TADARoute";
import { MachineRoute } from "./modules/MachineRoute/Machine";
import { EmployeeRoute } from "./modules/Employee/EmployeeRoute";
import MapTest from "../../Pages/Map/MapTest";
 

const LoginPage = lazy(() => import("../../Pages/FrontPage/index"));
const DownloadAppApk = lazy(() => import("../../Pages/DownloadAppApk/DownloadAppApk"));
const TestPage = lazy(() => import("../../Pages/TestPage/index"))


const ErrorPage = lazy(() => import("../../Pages/404ErrorPage"));

const Router = () => {
  return (
    <Suspense fallback={<div className="flex h-screen justify-center items-center"><Loader /></div>}>

      <Routes>

        <Route path="/" element={<LoginPage />} />
        <Route path="/DownloadApp.apk" element={<DownloadAppApk />} />
        <Route path="/track-travel/:userId/:travelId" element={<MapTest /> }/>
        <Route path="/layout" element={<ProtectedRoute><Layout /></ProtectedRoute>}>
          {
            [...HR, ...TravelRoute, ...TADARoute, ...MachineRoute].map((route) => (
              <Route key={route.path} {...route} />
            ))
          }
          <Route path="testPage" element={<TestPage />} />
          <Route path="*" element={<ErrorPage />} />
  
          {
            EmployeeRoute.map((route) => (
              <Route key={route.path} {...route} />
            ))
          }

        </Route> 

      </Routes>
    </Suspense>
  )

}

export default Router;
